<template>
	<el-dialog v-dialogDrag title="群发消息" :visible.sync="visible" width="850px" :close-on-click-modal="false">
		<div class="batch-send-container">
			<div class="left-panel">
				<div class="panel-header">
					<el-input placeholder="搜索好友" v-model="searchText" size="small" clearable>
						<i class="el-icon-search el-input__icon" slot="suffix"></i>
					</el-input>
				</div>
				<div class="select-all-bar">
					<el-checkbox v-model="isSelectAll" @change="onSelectAll">全选</el-checkbox>
					<span class="select-count">已选 {{ checkedFriends.length }} / {{ friends.length }}</span>
				</div>
				<el-scrollbar class="friend-scroll">
					<div v-for="friend in filteredFriends" :key="friend.id" class="friend-item"
						@click="toggleFriend(friend)">
						<el-checkbox v-model="friend._checked" @click.native.stop="" @change="onFriendCheckChange">
						</el-checkbox>
						<head-image :url="friend.headImage" :name="friend.nickName" :size="36"></head-image>
						<div class="friend-info">
							<span class="friend-name">{{ friend.nickName }}</span>
							<span v-if="friend.companyName" class="company-tag">@{{ friend.companyName }}</span>
						</div>
					</div>
				</el-scrollbar>
			</div>
			<div class="right-panel">
				<div class="panel-header">
					<span>消息内容</span>
					<el-select v-model="messageType" size="small" style="width: 120px; margin-left: 10px;">
						<el-option :value="0" label="文字消息"></el-option>
						<el-option :value="1" label="图片消息"></el-option>
						<el-option :value="2" label="文件消息"></el-option>
					</el-select>
				</div>
				<div class="message-input-area">
					<el-input v-if="messageType === 0" type="textarea" v-model="messageContent" :rows="6"
						placeholder="输入要群发的消息内容" maxlength="10240" show-word-limit></el-input>
					<div v-else-if="messageType === 1" class="upload-area">
						<file-upload :action="'/image/upload'" :maxSize="10 * 1024 * 1024"
							:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
							@success="onImageUploadSuccess">
							<div v-if="!uploadedData" class="upload-placeholder">
								<i class="el-icon-picture-outline"></i>
								<span>点击上传图片</span>
							</div>
							<div v-else class="upload-preview">
								<img :src="uploadedData.originUrl" alt="预览">
								<span>点击重新上传</span>
							</div>
						</file-upload>
					</div>
					<div v-else-if="messageType === 2" class="upload-area">
						<file-upload :action="'/file/upload'" :maxSize="10 * 1024 * 1024" @success="onFileUploadSuccess">
							<div v-if="!uploadedData" class="upload-placeholder">
								<i class="el-icon-wallet"></i>
								<span>点击上传文件</span>
							</div>
							<div v-else class="upload-preview">
								<i class="el-icon-document"></i>
								<span>{{ uploadedData.name || '文件已上传，点击重新上传' }}</span>
							</div>
						</file-upload>
					</div>
				</div>
				<div v-if="sendResult" class="send-result" :class="sendResult.type">
					{{ sendResult.message }}
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close()">取消</el-button>
			<el-button type="primary" :loading="sending" :disabled="!canSend" @click="onSend()">
				{{ sending ? '发送中...' : '群发' }}
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import FileUpload from '../common/FileUpload.vue';

export default {
	name: 'ChatBatchSend',
	components: { HeadImage, FileUpload },
	data() {
		return {
			visible: false,
			searchText: '',
			friends: [],
			messageType: 0,
			messageContent: '',
			uploadedData: null,
			sending: false,
			sendResult: null,
			isSelectAll: false,
		}
	},
	computed: {
		filteredFriends() {
			if (!this.searchText) return this.friends;
			const keyword = this.searchText.toLowerCase();
			return this.friends.filter(f =>
				(f.nickName && f.nickName.toLowerCase().includes(keyword)) ||
				(f.companyName && f.companyName.toLowerCase().includes(keyword))
			);
		},
		checkedFriends() {
			return this.friends.filter(f => f._checked);
		},
		canSend() {
			if (this.checkedFriends.length === 0) return false;
			if (this.messageType === 0) return !!this.messageContent.trim();
			return !!this.uploadedData;
		}
	},
	methods: {
		open() {
			this.visible = true;
			this.searchText = '';
			this.messageContent = '';
			this.messageType = 0;
			this.uploadedData = null;
			this.sending = false;
			this.sendResult = null;
			this.isSelectAll = false;
			this.loadFriends();
		},
		close() {
			this.visible = false;
		},
		loadFriends() {
			const storeFriends = this.friendStore.friends || [];
			this.friends = storeFriends.map(f => ({
				...f,
				_checked: false
			}));
		},
		toggleFriend(friend) {
			friend._checked = !friend._checked;
			this.onFriendCheckChange();
		},
		onFriendCheckChange() {
			this.isSelectAll = this.friends.length > 0 && this.friends.every(f => f._checked);
		},
		onSelectAll(val) {
			this.friends.forEach(f => { f._checked = val; });
		},
		onImageUploadSuccess(data) {
			this.uploadedData = data;
		},
		onFileUploadSuccess(data) {
			this.uploadedData = data;
		},
		async onSend() {
			const recvIds = this.checkedFriends.map(f => f.id);
			if (recvIds.length === 0) {
				this.$message.warning('请选择至少一个好友');
				return;
			}
			let content = '';
			if (this.messageType === 0) {
				content = this.messageContent.trim();
				if (!content) {
					this.$message.warning('请输入消息内容');
					return;
				}
			} else {
				if (!this.uploadedData) {
					this.$message.warning('请先上传文件');
					return;
				}
				content = JSON.stringify(this.uploadedData);
			}

			try {
				await this.$confirm(
					`确定要将消息群发给 ${recvIds.length} 个好友吗？`,
					'确认群发',
					{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
				);
			} catch {
				return;
			}

			this.sending = true;
			this.sendResult = null;
			try {
				const result = await this.$http({
					url: '/message/private/sendBatch',
					method: 'post',
					data: {
						recvIds: recvIds,
						content: content,
						type: this.messageType
					}
				});
				const successCount = result.length;
				const failCount = recvIds.length - successCount;
				if (failCount === 0) {
					this.sendResult = {
						type: 'success',
						message: `群发成功！已发送给 ${successCount} 个好友`
					};
				} else {
					this.sendResult = {
						type: 'warning',
						message: `发送完成：成功 ${successCount} 个，失败 ${failCount} 个（可能非好友或被拉黑）`
					};
				}
				// 将成功发送的消息插入到本地聊天记录
				result.forEach(msg => {
					const chat = this.chatStore.findChat(msg.recvId) || this.chatStore.findChatByFriend(msg.recvId);
					if (chat) {
						this.chatStore.insertMessage(msg, chat);
					}
				});
			} catch (e) {
				this.sendResult = {
					type: 'error',
					message: '群发失败：' + (e.message || '网络错误')
				};
			} finally {
				this.sending = false;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.batch-send-container {
	display: flex;
	gap: 16px;
	height: 450px;

	.left-panel {
		width: 320px;
		display: flex;
		flex-direction: column;
		border: var(--im-border);
		border-radius: 6px;
		overflow: hidden;

		.panel-header {
			padding: 10px;
			border-bottom: var(--im-border);
		}

		.select-all-bar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 6px 12px;
			font-size: var(--im-font-size-smaller);
			color: var(--im-text-color-light);
			border-bottom: var(--im-border);
		}

		.friend-scroll {
			flex: 1;
			overflow: hidden;
		}

		.friend-item {
			display: flex;
			align-items: center;
			padding: 8px 12px;
			cursor: pointer;
			gap: 10px;

			&:hover {
				background: var(--im-background-active-dark);
			}

			.friend-info {
				flex: 1;
				overflow: hidden;

				.friend-name {
					font-size: var(--im-font-size);
					color: var(--im-text-color);
				}

				.company-tag {
					font-size: var(--im-font-size-smaller);
					color: var(--im-text-color-light);
					margin-left: 6px;
				}
			}
		}
	}

	.right-panel {
		flex: 1;
		display: flex;
		flex-direction: column;
		border: var(--im-border);
		border-radius: 6px;
		overflow: hidden;

		.panel-header {
			display: flex;
			align-items: center;
			padding: 10px;
			border-bottom: var(--im-border);
			font-size: var(--im-font-size);
			font-weight: 500;
		}

		.message-input-area {
			flex: 1;
			padding: 12px;

			.upload-area {
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;

				.upload-placeholder {
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 8px;
					color: var(--im-text-color-light);
					cursor: pointer;
					padding: 30px;
					border: 2px dashed #dcdfe6;
					border-radius: 8px;

					i {
						font-size: 36px;
					}
				}

				.upload-preview {
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 8px;
					cursor: pointer;

					img {
						max-width: 200px;
						max-height: 150px;
						border-radius: 6px;
					}

					i {
						font-size: 48px;
						color: var(--im-color-primary);
					}

					span {
						font-size: var(--im-font-size-smaller);
						color: var(--im-text-color-light);
					}
				}
			}
		}

		.send-result {
			padding: 10px 12px;
			font-size: var(--im-font-size-smaller);
			border-top: var(--im-border);

			&.success {
				color: #67c23a;
			}

			&.warning {
				color: #e6a23c;
			}

			&.error {
				color: #f56c6c;
			}
		}
	}
}
</style>
